  <template>
  <div
    class="modal fade"
    id="update-header-photo"
    tabindex="-1"
    role="dialog"
    aria-labelledby="update-header-photo"
    aria-hidden="true"
  >
    <div
      style="width:470px"
      class="modal-dialog window-popup update-header-photo modal_profile"
      role="document"
    >
      <div class="modal-content">
        <a
          href="#"
          class="close icon-close"
          data-dismiss="modal"
          aria-label="Close"
          ref="close"
        >
          <svg class="olymp-close-icon">
            <use xlink:href="/svg-icons/sprites/icons.svg#olymp-close-icon" />
          </svg>
        </a>
        <div class="modal-header">
          <h6 class="title" v-if="modalId === 'update-header-photo'">
            Update your header photo
          </h6>
          <h6 class="title" v-else>Update your profile photo</h6>
        </div>
        <ModalUpdateHeaderPhoto
          v-if="modalId === 'update-header-photo'"
          @close-modal="$refs.close.click()"
          @updated="$emit('updated-header-photo')"
        />
        <ModalUpdateProfilePhoto
          v-if="modalId === 'update-profile-photo'"
          @close-modal="$refs.close.click()"
          @updated="$emit('updated-profile-photo')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ModalUpdateHeaderPhoto from "@/components/molecules/ModalUpdateHeaderPhoto";
import ModalUpdateProfilePhoto from "@/components/molecules/ModalUpdateProfilePhoto";
import UserHelperVue from "../../mixins/UserHelper.vue";
import ItemHelperVue from "../../mixins/ItemHelper.vue";
export default {
  name: "ModalUpdatePhoto",
  props: ["photo", "modalId"],
  mixins: [UserHelperVue, ItemHelperVue],
  components: {
    ModalUpdateHeaderPhoto,
    ModalUpdateProfilePhoto,
  },
};
</script>

<style lang="scss" scoped>
.icon-close {
  top: 6px;
  right: 10px;
}
@media only screen and (min-width: 900px) {
  .modal_profile {
    width: 30%;
  }
}
</style>
